//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "backbone", "./singleNumberReportView"], function (
  Marionette,
  Backbone,
  SingleNumberReportView,
) {
  "use strict";

  var SingleNumberReportController = Marionette.Controller.extend({
    initialize: function (options) {
      this.field = options.field || "value";
      this.name = "singleNumberReport";
      this.renderValue = options.renderValue;
      this.region = options.region;
      this.title = options.title;
    },
    show: function (dataSet) {
      this.dataSet = dataSet;
      this.model = new Backbone.Model({
        title: this.title,
      });
      this._setValueFromDataSet();
      dataSet.on("sync", this._setValueFromDataSet, this);
      dataSet.on("change:" + this.field, this._setValueFromDataSet, this);
      this.view = new SingleNumberReportView.view({ model: this.model });
      this.showRegion(this.view);
    },
    _setValueFromDataSet: function () {
      var value = this.dataSet.isSynced ? this.dataSet.get(this.field) : null;
      var noValue = value === null || value === undefined;
      if (typeof this.renderValue == "function") {
        value = this.renderValue(value);
      }
      this.model.set({
        noValue: noValue,
        value: value,
      });
    },
  });

  return SingleNumberReportController;
});
